import { MapPin, Phone, Mail, Clock, MessageCircle } from "lucide-react";
import PageHeader from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import LeadForm from "@/components/common/LeadForm";
import { COMPANY } from "@/data/content";

const Contact = () => (
  <div>
    <PageHeader
      eyebrow="Get in Touch"
      title="Let's talk engineering"
      subtitle="Reach out for enquiries, quotes, service requests or a plant visit. Our team responds within one business day."
    />
    <section className="py-12 md:py-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-[1fr_1.2fr] gap-12">
        {/* Info */}
        <div className="space-y-6">
          {[
            { icon: Phone, label: "Phone", value: COMPANY.phone, href: `tel:${COMPANY.phone}` },
            { icon: Mail, label: "Email", value: COMPANY.email, href: `mailto:${COMPANY.email}` },
            { icon: MessageCircle, label: "WhatsApp", value: "Chat with us", href: `https://wa.me/${COMPANY.whatsapp}` },
            { icon: MapPin, label: "Office", value: COMPANY.address },
            { icon: Clock, label: "Business Hours", value: COMPANY.hours },
          ].map((c) => (
            <Reveal key={c.label} className="bg-white border border-[#0055FF]/30 rounded-2xl p-6 flex items-start gap-4 card-hover">
              <div className="w-11 h-11 shrink-0 rounded-xl bg-[#0055FF]/15 border border-[#0055FF]/30 flex items-center justify-center"><c.icon className="w-5 h-5 text-[#0055FF]" /></div>
              <div>
                <p className="text-xs uppercase tracking-widest text-slate-500">{c.label}</p>
                {c.href ? <a href={c.href} className="mt-1 block text-slate-900 hover:text-[#0055FF] transition-colors" data-testid={`contact-${c.label.toLowerCase()}`}>{c.value}</a> : <p className="mt-1 text-slate-900">{c.value}</p>}
              </div>
            </Reveal>
          ))}
        </div>

        {/* Form */}
        <Reveal className="bg-white border border-[#0055FF]/30 rounded-2xl p-8 md:p-10">
          <h2 className="text-2xl mb-6">Send us a message</h2>
          <LeadForm kind="contact" />
        </Reveal>
      </div>
    </section>

    {/* Map */}
    <section className="pb-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="rounded-2xl overflow-hidden border border-slate-200 h-[420px]">
          <iframe title="Accurate Automation and Reconditioners — location" src={COMPANY.mapEmbed} width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="google-map" />
        </div>
      </div>
    </section>
  </div>
);

export default Contact;
